import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAlt"><Path d="M7.13325 12.5679L7.6894 10.4387H7.72261L8.27876 12.5679H7.13325Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM6.602 9.01099L4.64717 15H6.49824L6.80952 13.8088H8.60249L8.91377 15H10.7648L8.81001 9.01099H6.602ZM11.1344 9.01099V15H15.2433V13.6055H12.8942V9.01099H11.1344ZM15.9537 10.4055V15H17.7134V10.4055H19.2906V9.01099H14.3765V10.4055H15.9537Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlt;
